module.exports = __webpack_public_path__ + "img/HeimwehScreenshot12.4fbfdc72.png";